export default {
  default: 'default',
  presenter: 'presenter',
  overview: 'overview',
  grid: 'grid',
  print: 'print',
}
